<template>
    <v-scale-transition>
        <v-card flat tile color="transparent" class="pt-5" v-show="visible">
            <v-card flat tile color="transparent" max-width="700">
                <div class="black--text text-left">

                    <markdown-editor
                            v-model="contentModel"
                            v-if="editMode"
                            hint="Signature contents"
                    >
                        <v-tooltip top color="primary" :close-delay="400" :open-delay="400">
                            <template v-slot:activator="{ on }">

                                <div v-on="on">
                                    <vue-markdown
                                            :watches="['source','show']"
                                            :source="contentModel"
                                            class="markdown"
                                            :linkify="false"
                                            :emoji="false"
                                            :html="false"
                                            :breaks="true"
                                            :anchorAttributes="{target: '_blank'}"
                                    ></vue-markdown>
                                </div>
                            </template>
                            <span>Click to edit</span>
                        </v-tooltip>
                    </markdown-editor>

                    <div v-else>
                        <vue-markdown
                            :watches="['source','show']"
                            :source="contentModel"
                            class="markdown"
                            :linkify="false"
                            :emoji="false"
                            :html="false"
                            :breaks="true"
                            :anchorAttributes="{target: '_blank'}"
                        ></vue-markdown>
                    </div>
                </div>
            </v-card>
        </v-card>
    </v-scale-transition>
</template>

<script>

    import VueMarkdown from '@adapttive/vue-markdown';
    import TextEditor from "../TextEditor";
    import MarkdownEditor from "../MarkdownEditor";

    export default {

        components: {
            TextEditor,
            MarkdownEditor,
            VueMarkdown
        },

        props: {
            value: {
                type: String | null,
                required: true,
            },
            backgroundColor: {
                type: String,
                required: true,
            },
            visible: {
                type: Boolean,
                required: true,
            },
            editMode: {
                type: Boolean,
                required: false,
                default: true,
            },
        },

        computed: {

            contentModel: {
                get() {
                    return this.value ? this.value : '';
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
        },
    }
</script>

